//
// JobContentElementController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./VisualElementController";
import "../../models/visualElements/JobContentElement";

var JobContentElementController = createModule("BIRD::JobContentElementController", ["BIRD::BIRDModelController","BIRD::RendererManagerController","BIRD::VisualElementController"], EventDispatcher, [
    {
        JOB_EXECUTION_FAILED: 50007,
    },
    ,
    ,
    ,
    {
        getJobResultsUri: [7],
        getModel: [1],
        showTooltip: [0],
        getExecutionUri: [7,4],
    },
    {
        _create: [4,1],
    },
    ,
]);
export default JobContentElementController;
